__webpack_require__.p = "https://static.recollective.com/v1.6.19-012/_inc/dist/";